import { render } from "./FeedbackWidget.vue?vue&type=template&id=d6ff809e&scoped=true"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js"

import "./FeedbackWidget.vue?vue&type=style&index=0&id=d6ff809e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ff809e"]])

export default __exports__